import { isTouchPrimary } from '../utils/deviceInfo';

export default function TutorialPopup({ hint, onClose }) {
  const verb = isTouchPrimary() ? 'touch' : 'drag';
  return (
    <div
      id="tutorial_modal_overlay"
      onClick={(event) => { if (event.target === event.currentTarget) onClose(); }}
    >
      <div role="dialog" aria-modal="true" aria-labelledby="tutorial_modal_title" id="tutorial_modal">
        <h2 id="tutorial_modal_title">How to play</h2>
        <button
          id="tutorial_modal_close"
          type="button"
          aria-label="Close"
          onClick={onClose}
        >×</button>
        <p id="tutorial_modal_instructions">
          To solve the joke and reveal the image, {verb} one of the words below the image
          and place it in the correct location to form the punchline of the joke.
        </p>
        {hint.word && (
          <p id="tutorial_modal_hint">
            Here's a hint - the {hint.ordinal} word is "{hint.word}"
          </p>
        )}
        <button id="tutorial_modal_got_it" type="button" onClick={onClose}>
          Got it
        </button>
      </div>
    </div>
  );
}
